import { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';
import './ValdostaHero.css';
import { bookingHref, stayProperties } from './stayProperties';
import PropertyGallery from '../components/PropertyGallery';

gsap.registerPlugin(useGSAP, ScrollTrigger);

export default function ValdostaHero({ property = stayProperties.georgia }) {
  const scope = useRef(null);

  useGSAP(() => {
    const media = gsap.matchMedia();
    media.add('(prefers-reduced-motion: no-preference)', () => {
      const q = gsap.utils.selector(scope);
      gsap.timeline({ defaults: { duration: .8, ease: 'power3.out', clearProps: 'transform,opacity,visibility' } })
        .from(q('.valdosta-hero__breadcrumb'), { autoAlpha: 0, y: 8 })
        .from(q('.valdosta-hero__eyebrow'), { autoAlpha: 0, y: 10 }, .08)
        .from(q('.valdosta-hero__heading'), { autoAlpha: 0, y: 28 }, .16)
        .from(q('.valdosta-hero__address'), { autoAlpha: 0, y: 15 }, .28)
        .from(q('.valdosta-hero__check-dates'), { autoAlpha: 0, x: 20 }, .34)
        .from(q('.valdosta-hero__image-wrap'), { autoAlpha: 0, scale: .98 }, .3)
        .from(q('.valdosta-hero__info-card'), { autoAlpha: 0, x: 30 }, .38)
        .from(q('.valdosta-hero__leaf'), { autoAlpha: 0, scale: .96, y: 8 }, .55);
      const bird = gsap.to(q('.valdosta-hero__leaf'), { y: -3, x: 2, rotation: 1, duration: 5, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 1.4, paused: true, scrollTrigger: { trigger: scope.current, start: 'top 85%', end: 'bottom top', toggleActions: 'play pause resume pause' } });
      return () => bird.kill();
    });
    return () => media.revert();
  }, { scope });

  return (
    <section ref={scope} className="valdosta-hero" aria-labelledby="valdosta-hero-title">
      <div className="valdosta-hero__inner">
        <p className="valdosta-hero__breadcrumb"><a href="/">Home</a><span aria-hidden="true"> / </span><a href="/stay">Our stays</a><span aria-hidden="true"> / </span>{property.name}</p>
        <div className="valdosta-hero__copy">
          <p className="valdosta-hero__eyebrow">{property.name.toUpperCase()}</p>
          <h1 className="valdosta-hero__heading" id="valdosta-hero-title">{property.title[0]}<br /><span>{property.title[1]}</span></h1>
          <div className="valdosta-hero__meta">
            <p className="valdosta-hero__address">{property.location}</p>
            {property.comingSoon ? <span className="valdosta-hero__check-dates" aria-label="Booking is not yet available">Coming soon</span> : <a className="valdosta-hero__check-dates" href={bookingHref(property.id)}>Check dates <span aria-hidden="true">↗</span></a>}
          </div>
        </div>
        <div className="valdosta-hero__media-grid">
          <div className="valdosta-hero__image-wrap">
            {property.gallery?.length ? <PropertyGallery images={property.gallery} alt="JamRock Escape property" /> : property.image ? <img src={`${process.env.PUBLIC_URL}/images/${property.image}`} alt={property.alt} width="900" height="600" fetchPriority="high" /> : <div className="property-photo-pending">Property photographs to follow</div>}
            
          </div>
          <aside className="valdosta-hero__info-card">
            <img className="valdosta-hero__leaf" src={`${process.env.PUBLIC_URL}/images/hummingbird.svg`} alt="" width="180" height="140" />
            <h2>Picture yourself here.</h2>
            <p>{property.comingSoon ? <>This stay is coming soon.<br />Booking is not yet available.<br />Check back for updates.</> : <>Take time to rest and recharge.<br />Explore the details below<br />or ask your host a question.</>}</p>
            <a href="/contact">Ask about this stay</a>
          </aside>
        </div>
      </div>
    </section>
  );
}
